// eslint-disable-next-line import/prefer-default-export
export var ACCEPT_HEADER_VALUE_FOR_DOCUMENTS = 'application/json, application/yaml';